import { createFileRoute } from '@tanstack/react-router'
import { surveySearchSchema } from '@/features/surveys/filter-surveys/model/surveySearch'
import { SurveysPage } from '@/pages/surveys/ui/SurveysPage'

export const Route = createFileRoute('/surveys')({
  validateSearch: surveySearchSchema,
  component: SurveysPage,
})
